import React, { Component } from "react";
import ReactGA from "react-ga";
import BannerImg from "../../assets/images/banner/project-management.png";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

class ProjectManagement extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Project Management & Enterprise Delivery Experience | Avani Cimcon</title>
          <meta
            name="keywords"
            content="project management, practical project management, risk management projects, project management tools, project planning tool, project planning and implementation, product management, software development, enterprise delivery, managed engineering teams, modernization delivery, offshore service, program management applications"
          />
          <meta
            name="description"
            content="Project management at Avani Cimcon is part of enterprise delivery, governance, and modernization execution. It supports client trust, reporting, quality control, and long-term partnership."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/project-management" />
        </Helmet>

        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Project Management</h1>
            <h5>Enterprise delivery experience</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <p className="font-weight-bold text-primary">
                Project management is how enterprise modernization stays controlled, visible, and
                trustworthy. Avani Cimcon combines delivery governance, communication protocols,
                and QA discipline so clients can evolve complex systems without losing oversight.
              </p>
              <p>
                Project management is the key to a successful distributed delivery relationship. One
                of the main apprehensions for an outsourcing organization is its inability to
                physically monitor and control remote projects. Long lasting relationships are based
                on client trust and confidence in the ability of the delivery partner to deliver as
                committed.
              </p>
              <p>
                Avani Cimcon Technologies (ACT) with its varied and long experience has evolved
                innovative, practical project management, communication protocols, and QA processes
                customized for enterprise software delivery. These keep the client abreast of what's
                happening at the remote site on a daily basis without additional effort.
              </p>
              <p>
                Avani Cimcon Technologies understands that it is essential to keep the client
                informed of the progress of the project and convey this information to the client in
                an acceptable and understandable format. To do this Avani Cimcon Technologies takes
                the help of tools like a project-planning tool (e.g. MS project), standardized
                format reporting and a net-based information exchange and tracking system.
              </p>
              <p>
                Effective information sharing gives comfort to the client and builds their
                confidence and trust in the relationship. We clearly understand that only an in-time
                project implementation with the desired quality would allow the client to reap the
                benefits of going offshore.
              </p>
              <p>
                This section gives an idea of how the different stages in an offshore project are
                managed and reported.
              </p>

              <div className="mt-4 p-4 bg-light border rounded">
                <h5 className="text-primary mb-3">Why delivery discipline matters in modernization</h5>
                <ul className="mb-0">
                  <li className="mb-2">
                    <Link to="/it-consulting-services">Control modernization programs with clear governance and execution</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/quality-assurance">Reduce risk by pairing delivery discipline with QA</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/value-proposition">Strengthen client trust through visible progress and reporting</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Talk to us about enterprise delivery or modernization governance</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ProjectManagement;
